import styled from "@emotion/styled";
import { PureComponent } from "react";

import { ISelectedWidget } from "interfaces/customerDetailsWidgetInterface";

import { CustomerDetailsWidgetContainer } from "./CustomerDetailsWidgetContainer";

interface IStyledContainerProps {
  isVisible: boolean;
}
const StyledContainer = styled.div<IStyledContainerProps>`
  flex: 1;
  display: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.isVisible ? "flex" : "none")
  };
  border: 0;
  height: 100%;
`;

interface IProps {
  isVisible: boolean;
  widgets: ISelectedWidget[];
  selectedWidgetId: string;
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  context?: any;
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onCustomerDetailsSectionChange?(msg: any): void;
}

/**
 * @deprecated
 */
export class CustomerDetailsWidgets extends PureComponent<IProps> {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const { isVisible, widgets, selectedWidgetId, onCustomerDetailsSectionChange } = this.props;

    return (
      <StyledContainer isVisible={isVisible}>
        {widgets.map((widget: ISelectedWidget) => (
          <CustomerDetailsWidgetContainer
            key={widget.id}
            widget={widget}
            isVisible={widget.id === selectedWidgetId}
            onCustomerDetailsSectionChange={onCustomerDetailsSectionChange}
            context={this.props.context}
          />
        ))}
      </StyledContainer>
    );
  }
}
